import { createSelector } from 'reselect';
import { BEACONS } from '../constants/beacon.constants';
import { initialState } from '../reducers/beacon.reducer';
import {ADMIN_PAGE} from "../../containers/AdminPage/constants";
import {fromJS, List} from "immutable";

const selectState = state => state?.[BEACONS] || initialState;
const selectAdminState = state => state?.[ADMIN_PAGE] || fromJS({});

const selectBeaconsData = createSelector(
	selectState,
	state => state.get('data')
);

const selectBeaconsList = createSelector(
	[selectBeaconsData, selectAdminState],
	(data, adminState) => {
		const beacons = data.toList();
		if(!beacons?.size) {
			return List(adminState.get('beacons'));
		}
		return beacons;
	}
);

export const selectBeacons = createSelector(
	selectBeaconsList,
	beacons => beacons.sortBy(b => b.name.toLowerCase())
);

export const selectBeaconsFetched = createSelector(
	selectState,
	state => state.get('fetched')
);

export const selectSelectedBeacon = createSelector(
	selectState,
	state => state.get('selectedBeacon')
);